const action = 'WORKSPACE_MEMBERS';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { workspaceId }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: the unwrapped GET /workspace/<id>/members body ({ members })
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
